import {useState} from "react";
import UsersList from "../components/UsersList";
import UserForm from "../components/UserForm";
import {Box, Modal} from "@mui/material";
import {useAlert} from "../context/AlertContext";
import {ApiError} from "../types/api-errors";

const UsersPage = () => {
    const [open, setOpen] = useState(false);
    const {showAlert} = useAlert();
    const [refresh, setRefresh] = useState(false);

    const refreshUsers = () => setRefresh(prev => !prev);

    const handleUserAdded = () => {
        setOpen(false);
        refreshUsers();
        showAlert("User added successfully!", "success");
    };

    const handleError = (error: ApiError | any) => {
        const msg =
            typeof error === "string"
                ? error
                : error?.message ?? "Unexpected error";
        showAlert(msg, "error");
    };

    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <UsersList onAdd={() => setOpen(true)} refreshTrigger={refresh} refreshUsers={refreshUsers}/>
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box sx={{margin: "auto", width: 400}}>
                    <UserForm onClose={() => setOpen(false)} onSuccess={handleUserAdded} onError={handleError}/>
                </Box>
            </Modal>
        </Box>
    );
};

export default UsersPage;
